import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Option } from '../../modules/Dropdown';
import { tracker } from '../../../services/tracker';
import { Track, Tracks } from '../../../models/tracks/track';
import TodayReport from '../../modules/TodayReport';
import Report from "../../modules/Report";
import { analyticsApi } from '../../../services/analytics';

const Tracker = () => {
  const [tracks, setTracks] = useState<Track | Track[]>();

  useEffect(() => {
    fetchData();
    analyticsApi.logEvent(
      '',
      'View',
      {},
      'Main'
    );
  }, []);

  const [options, setOptions] = useState<Option[]>([
    { key: 1, value: 'Today' },
    {
      key: 7,
      value: 'Week',
    },
    {
      key: 30,
      value: 'Month',
    },
  ]);

  const [selected, setSelected] = useState<Option>({
    key: 1,
    value: 'Today',
  });

  const onSelect = (navigation: string) => {
    if(navigation === 'next') {
      const currentIndex = options.findIndex((item) => item.key === selected.key)
      if(currentIndex === options.length - 1) {
        setSelected(options[0])
      } else {
        setSelected(options[currentIndex + 1])
      }
    } else {
      const currentIndex = options.findIndex((item) => item.key === selected.key)
      if(currentIndex === 0) {
        setSelected(options[options.length - 1])
      } else {
        setSelected(options[currentIndex - 1])
      }
    }
  };

  useEffect(() => {
    fetchData(+selected.key)
  }, [selected])

  const fetchData = async (limit: number = 1) => {
    const data = await tracker.get(limit);
    if (Array.isArray(data) && data.length > 1) {
      setTracks(new Tracks(data).tracks);
    } else {
      setTracks(new Track(data[0]));
    }
  };

  return (
    <>
      <div className={styles.body}>
        <div className={styles.filters}>
          <div className={styles.filters_left} onClick={() => {
            onSelect('prev')
          }}><img src="/assets/images/chevron_left.svg" alt="" /></div>
          <div className={styles.filters_options}>
            {
              options.map((option) => {
                return <div className={`${styles.filters_option} ${option.key === selected.key ? styles.filters_option_active : ''}`}>{option.value}</div>
              })
            }
          </div>
          <div className={styles.filters_right} onClick={() => {
            onSelect('next')
          }}><img src="/assets/images/chevron_right.svg" alt="" /></div>
        </div>
        {tracks && !Array.isArray(tracks) && (
          <TodayReport
            onAddNewMealGroup={fetchData}
            onFinishDay={fetchData}
            track={tracks}
          />
        )}
        {tracks && Array.isArray(tracks) && (
          <Report
            tracks={tracks}
          />
        )}
      </div>
    </>
  );
};

export default Tracker;
